import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { CreationSourceEditorContext } from '../../manager'
import Input from './input'

const Inputs = styled.div`
    grid-column: span 8;
`

const CreationSourceEditorCaptionInputs = () => {
    const { source, captions, captionStyle, setCaptions } = useContext(CreationSourceEditorContext)
    const [activeCaptionIndex, setActiveCaptionIndex] = useState<number>()

    useEffect(() => {
        if (!captions.length) {
            addNewCaption()
        }
    }, [captions])

    const addNewCaption = () => {
        setCaptions([
            ...captions,
            {
                text: '',
                style: { ...captionStyle },
                x: source.width / 2,
                y: source.height * 0.9,
                rotation: 0,
            },
        ])
    }

    const removeCaptionByIndex = (index: number) => {
        const newCaptions = [...captions]
        newCaptions.splice(index, 1)
        setCaptions(newCaptions)
    }

    return (
        <Inputs>
            {captions.map((caption, i) => (
                <Input
                    key={`source-editor-caption-input-${i}`}
                    {...{
                        caption,
                        active: i === activeCaptionIndex,
                        index: i,
                        onAdd: addNewCaption,
                        onRemove: () => removeCaptionByIndex(i),
                        onFocus: () => setActiveCaptionIndex(i),
                    }}
                />
            ))}
        </Inputs>
    )
}

export default CreationSourceEditorCaptionInputs
